import React from "react";
import { Link, useLocation } from "react-router-dom";
import { FiHome, FiMapPin, FiUsers, FiZap, FiMenu } from "react-icons/fi";
import "./MobileAppNav.scss";

const TABS = [
  { to: "/Dashboard", label: "Home", icon: FiHome, end: true },
  {
    to: "/patient-list",
    label: "Directory",
    icon: FiUsers,
    matchPaths: ["/patient-list", "/doctor-list", "/hospital-list"],
  },
  { to: "/location-search", label: "Map", icon: FiMapPin },
  { to: "/Bid", label: "Bids", icon: FiZap, end: true },
];

function tabIsActive(pathname, tab) {
  const p = pathname.toLowerCase();
  if (tab.matchPaths?.length) {
    return tab.matchPaths.some((x) => {
      const xl = x.toLowerCase();
      return p === xl || p.startsWith(`${xl}/`);
    });
  }
  const t = tab.to.toLowerCase();
  if (tab.end) {
    return p === t;
  }
  return p === t || p.startsWith(`${t}/`);
}

export default function MobileAppNav({ onOpenMenu }) {
  const location = useLocation();
  const pathname = location.pathname;

  return (
    <nav className="mobile-app-nav" aria-label="Primary">
      <div className="mobile-app-nav__inner">
        {TABS.map((tab) => {
          const Icon = tab.icon;
          const active = tabIsActive(pathname, tab);
          return (
            <Link
              key={tab.to}
              to={tab.to}
              className={`mobile-app-nav__item${active ? " mobile-app-nav__item--active" : ""}`}
            >
              <span className="mobile-app-nav__icon-wrap" aria-hidden>
                <Icon className="mobile-app-nav__icon" strokeWidth={2.25} />
              </span>
              <span className="mobile-app-nav__label">{tab.label}</span>
            </Link>
          );
        })}
        <button
          type="button"
          className="mobile-app-nav__item mobile-app-nav__item--more"
          onClick={onOpenMenu}
          aria-label="Open full menu"
        >
          <span className="mobile-app-nav__icon-wrap" aria-hidden>
            <FiMenu className="mobile-app-nav__icon" strokeWidth={2.25} />
          </span>
          <span className="mobile-app-nav__label">More</span>
        </button>
      </div>
    </nav>
  );
}
